import { AccountMenu } from '@mfox/shared/ui/AccountMenu'
import { Logo } from '@mfox/shared/ui/Logo'
import './SiteHeader.css'

/**
 * The header for pages outside the app frame (sign-in, onboarding, not found): the logo home and, at the right,
 * the account menu, which is just the theme switch when nobody is signed in.
 */
export function SiteHeader() {
  return (
    <header className="site-header">
      <Logo to="/" />
      <AccountMenu />
    </header>
  )
}
